// extracted by mini-css-extract-plugin
module.exports = {"container":"container__83CYs","icon":"icon__GbMNX","h":"h__1Bd-e","desc":"desc__3pj9B"};